'use client'
import React from 'react'
import styles from './styles.module.scss'

export const Label = (props: any) => (
  <label className={styles.label} {...props} />
)
